<template>
  <!-- 对话框 -->
  <el-dialog title="司机钱包" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">

        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">保证金:</span>
          {{ form.bond }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">余额:</span>
          {{ form.balance }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">已提现:</span>
          {{ form.cash }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">已冻结:</span>
          {{ form.frozen }} 元
        </p>

        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">服务费:</span>
          {{ form.insurance }} 元
        </p>


        <el-button @click="edit_wallet = !edit_wallet" style="margin: 20px auto;display: block;">更改司机钱包</el-button>

        <div v-if="edit_wallet">
          <el-form-item label="操作方式:" label-width='120px'>
            <el-radio-group v-model="submit_data.operation">
              <el-radio-button label="bond">保证金</el-radio-button>
              <el-radio-button label="balance">余额</el-radio-button>
              <el-radio-button label="cash">已提现</el-radio-button>
              <el-radio-button label="frozen">已冻结</el-radio-button>
              <el-radio-button label="insurance">服务费</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="模式:" label-width='120px'>
            <el-radio-group v-model="submit_data.mode">
              <el-radio-button label="add">+</el-radio-button>
              <el-radio-button label="sub">-</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="金额:" label-width='120px'>
            <el-input v-model="submit_data.amount" :placeholder="submit_rules.amount.placeholder">
            </el-input>
          </el-form-item>

        </div>
      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="walletSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        
        _this.submit_data.driver_code = _this.data;

        _this.walletInit();

      },

    },
    data() {
      return {

        show: false,

        // 修改钱包按钮开关
        edit_wallet: false,

        // 表单数据
        form: {
          bond: '0.00',
          balance: '0.00',
          cash: '0.00',
          frozen: '0.00',
          insurance: '0.00'
        },

        // 表单提交数据
        submit_data: {
          driver_code: '',
          mode: '',
          operation: '',
          amount: ''
        },

        submit_rules: {
          mode: {
            placeholder: '模式',
            rules: {
              required: true,
              message: '未选择模式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          operation: {
            placeholder: '操作方式',
            rules: {
              required: true,
              message: '未选择操作模式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          amount: {
            placeholder: '请输入金额',
            rules: {
              required: true,
              message: '金额需为1-999999的数字',
              regulation: 'egt',
              rulesData: 0
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {
      // 获取钱包信息
      walletInit(){
        _this.$post(
            '/driver/getDriverWallet', {
              driver_code: _this.submit_data.driver_code
            }
          )
          .then(res => {

            // 将获取到的数据赋值
            _this.form.bond=res.data.bond;
            _this.form.balance=res.data.balance;
            _this.form.cash=res.data.cash;
            _this.form.frozen=res.data.frozen;
            _this.form.insurance=res.data.insurance;
          }).catch((err) => {

          })
      },
      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

        _this.money = 0;

      },

      // 提交按钮
      walletSubmit() {

        _this.$post(
            '/driver/editDriverWallet',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            console.log(res);

            _this.$message.success({
						message: '更改成功',
						duration:1500
					});

            // 重新获取钱包信息
            _this.walletInit();


          }).catch((err) => {

          })

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>